interface NaturalToken {
  numeric: boolean
  value: string
}

function naturalTokens(value: string): NaturalToken[] {
  return (value.match(/\d+|\D+/gu) ?? []).map((token) => ({
    numeric: /^\d+$/u.test(token),
    value: token,
  }))
}

function normalizedDigits(value: string): string {
  const normalized = value.replace(/^0+(?=\d)/u, '')
  return normalized || '0'
}

export function naturalSampleCompare(left: string, right: string): number {
  const leftTokens = naturalTokens(left)
  const rightTokens = naturalTokens(right)
  const length = Math.min(leftTokens.length, rightTokens.length)
  for (let index = 0; index < length; index += 1) {
    const leftToken = leftTokens[index]
    const rightToken = rightTokens[index]
    if (leftToken.numeric && rightToken.numeric) {
      const leftDigits = normalizedDigits(leftToken.value)
      const rightDigits = normalizedDigits(rightToken.value)
      if (leftDigits.length !== rightDigits.length) return leftDigits.length - rightDigits.length
      const numericOrder = leftDigits.localeCompare(rightDigits)
      if (numericOrder) return numericOrder
      continue
    }
    if (leftToken.numeric !== rightToken.numeric) return leftToken.numeric ? -1 : 1
    const insensitiveOrder = leftToken.value.localeCompare(rightToken.value, 'en', {
      sensitivity: 'base',
    })
    if (insensitiveOrder) return insensitiveOrder
  }
  return leftTokens.length - rightTokens.length
}
